import type { Options } from '@Types/Shared/Options';
import type { MenuType } from '@Types/Shared/SiteDatas';

import { getHeaderBtnSettingsToCSS } from '@Blocks/_lib/btns';

import { Button } from '@/src/Views/Shared/Button/Button';

import { getSingleBtnStyle } from '../../GlobalStyles/GlobalStyles';

export default function CtaMenu({
	CTAMenu,
	btnStyle,
	minosOptions,
	navType,
}: {
	CTAMenu?: MenuType[];
	btnStyle: string;
	minosOptions: Options;
	navType: string;
}) {
	const _btnStyle = getHeaderBtnSettingsToCSS(
		getSingleBtnStyle(minosOptions, btnStyle),
		navType === 'topNav' ? 'topNav' : 'mainNav'
	);

	return (
		<div className={navType === 'topNav' ? 'py-4' : 'py-5'}>
			<ul className='flex flex-col gap-8 desktop:flex-row'>
				{CTAMenu?.map((item: MenuType) => {
					return (
						<li key={item.id} className=''>
							<Button
								label={item.title}
								url={item.url}
								style={'primary'}
								urlType={'link'}
								urlOpenNewTab={false}
								btnHasIcon={_btnStyle?.btnHasIcon}
								btnDecorationElement={_btnStyle?.btnDecorationElement}
								animation={_btnStyle?.animation}
								btnClassName={_btnStyle}
							/>
						</li>
					);
				})}
			</ul>
		</div>
	);
}

// <Button
// 								label={archiveLink.label}
// 								url={linkIndex}
// 								style={archiveLink.type}
// 								urlType={'link'}
// 								urlOpenNewTab={archiveLink.target}
// 								btnHasIcon={archiveLinkStyles?.btnHasIcon}
// 								btnDecorationElement={archiveLinkStyles?.btnDecorationElement}
// 								className='minos-events-btn-archivelink tablet:minos-events-btn-archivelink'
// 								animation={archiveLinkStyles?.animation}
// 								btnClassName={getArchiveBtnSettingsToCSS(archiveLinkStyles, 'events')}
// 							/>
